<template>
  <div class="rate-body">
    <div class="rate-container">
      <Rate v-model="rateValue" color="#ffd21e" :size="28"></Rate>
    </div>
    <div class="comment-container">
      <Field v-model="commentText"
             type="textarea"
             class="input-comment"
             rows="8"
             :placeholder=placeholder
             autofocus
      >
      </Field>
    </div>
  </div>
</template>

<script>
  import {Field, Toast, Rate} from "vant"
  export default {
    name: "UserItemRate",
    components: {Field, Rate},
    props: {
      itemId: {
      }
    },
    data() {
      return {
        rateValue: 0,
        commentText: "",
        placeholder: "我的点评......",
      }
    },
    mounted(){
    },
    methods: {
      async onPost() {
        if (!this.itemId) {
          Toast("参数错误")
          return
        }

        if (!this.rateValue) {
          Toast("请评分")
          return
        }

        if (!this.commentText) {
          Toast("还没填写你的看法")
          return;
        }

        let params = {
          "item_id": this.itemId,
          "rate_value": parseFloat(this.rateValue),
          "comment_text": this.commentText,
        }
        await this.$store.dispatch("DoItemRateAction", params).then((data)=> {
          if (data.code === 0) {
          } else if (data.code === 20014){
          } else {
          }
          this.$emit("rateResult", data.code)
        }, ()=> {
          Toast("网络错误")
        })
      },
      setRate(value) {
        if (value && parseFloat(value)) {
          this.rateValue = parseFloat(value)
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .rate-container {
    text-align: center;
  }

  .comment-container {
    padding: 24px 12px;
    border-bottom: 1px solid #f2f2f2;
    .input-comment {
      font-size: 16px;
    }
  }
</style>
